import { v4 as uuidv4 } from "uuid";
export class GuidItemModel {
    constructor() {
        this.id = uuidv4();
        this.value = "";
        this.code = "";
        this.isSelected = false;
    }
}
export default class GuidItem extends GuidItemModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
